module.exports = __webpack_public_path__ + "static/media/acquisition_unselected.9b15fba6.svg";